<template>
  <v-container fluid>
    <search-view :show-search-options="false"
                 :show-search-date-options="false"
                 :show-search-date="false"
                 :show-add-button="true"
                 @addEvent="addNew"
                 @initEvent="searchEvent"
                 @searchEvent="searchEvent"
                 @reset="reset"></search-view>

    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"
                    @cellEvent="cellEvent"/>
      </v-flex>
    </v-layout>

    <sale-detail
        :title="editView.title"
        :visible="editView.visible"
        :item-detail="editView.item"
        :show-cancel="editView.showCancel"
        :isEdit="editView.isEdit"
        @cancelEvent="editView.cancelEvent"
        @confirmEvent="editView.confirmEvent"
      @successEvent="editView.successEvent"/>
  </v-container>
</template>

<script>
import TableView from "@/components/TableView";
import SaleDetail from "./SaleDetail";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import SearchView from "@/components/SearchView";
import {getRandomCode} from '@/utils/tools';

export default {
  name: "sale",
  components: {
    SearchView, TableView, SaleDetail
  },
  mixins: [common],
  data() {
    return {
      loading: false,
      filter: -1,
      startDate: '',
      endDate: '',
      searchKey:'',
      searchValue:'',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      editView: {
        visible: false,
        key: 'add',
        item: null,
        showCancel: true,
        confirmEvent: ()=>{},
        cancelEvent: ()=>{},
        successEvent: ()=>{}
      },
    };
  },
  created() {
    this.loadData();
  },
  computed:{
    ...mapGetters([]),
    getColumnKeys(){
      return [
        { value:'edit', text:'編輯' , isEvent: true, color: this.Theme.GREEN, sortable: false },
        { value:'coupon', text:'優惠代碼' },
        { value:'startDate', text:'開始時間' },
        { value:'endDate', text:'結束時間' },
        { value:'content', text:'簡介', sortable: false },
        { value:'price', text:'折扣', sortable: false },
        { value:'conditionPrice', text:'條件', sortable: false },
        { value:'createdDate', text:'建立時間', sortable: false },
        { value:'delete', text:'刪除' , isEvent: true, color: this.Theme.YELLOW, sortable: false },
      ]
    }

  },
  methods:{
    ...mapActions(['getSalePageList','deleteSaleInfo']),
    changeFilterType(){
      this.loadData();
    },
    async loadData(){
      this.loading = true;
      let searchQuery = [
        { key: 'isDelete', value: 0 },
      ];

      if (this.searchValue !== ''){
        searchQuery.push({ key:'coupon', value: this.searchValue});
      }
      const res = await this.getSalePageList({
        pageIndex: this.pagination.page,
        limit: this.pagination.itemsPerPage,
        startDate: `${this.startDate}`,
        endDate: `${this.endDate}`,
        searchQuery: searchQuery,
      });

      const result = res.data;
      if (result.statusCode === 0){
        this.list = result.data.list;
        this.pagination.totalItems = result.data.header.totalCount;

        console.log(`getSaleList ${JSON.stringify(result.data.list)}`);
      }
      this.loading = false;
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page){
      this.pagination.page = page.page;
      this.pagination.itemsPerPage = page.itemsPerPage;
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    /**
     * 列表按鈕點擊事件
     * @param cell Object - { key: 事件代碼, item: 物件 }
     * */
    cellEvent(cell){
      console.log(`cellEvent ${cell.key} ${JSON.stringify(cell.item)}`);
      if (cell.key === 'delete'){
        this.showAlert({
          title: '提示',
          content: '是否確定要刪除此項目？',
          confirmEvent: async () => {
            this.hideAlert();
            await this.deleteEvent(cell.item);
          }
        });
      } else {
        this.editView.title = cell.key === 'add' ? '新增優惠代碼':'修改優惠代碼';
        let itemDetail = Object.assign({}, cell.item);

        this.editView.key = cell.key;
        this.editView.item = itemDetail;
        this.editView.visible = true;
        this.editView.isEdit = cell.key !== 'add';
        this.editView.cancelEvent = ()=>{
          this.editView.visible = false;
        }
        this.editView.confirmEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        }
        this.editView.successEvent = ()=>{
          this.editView.visible = false;
          this.loadData();
        };
      }

    },
    searchEvent(info){
      this.startDate = info.startDate;
      this.endDate = info.endDate;
      this.searchKey = info.searchKey;
      this.searchValue = info.searchValue;

      this.loadData();
    },
    reset(){
      this.searchKey = '';
      this.searchValue = '';
      this.loadData();
    },
    async deleteEvent(item){
      const res = await this.deleteSaleInfo({
        couponId: item.couponId,
      });

      if (res.data.statusCode === 0){
        this.reset();
      }
    },
    addNew(){
      this.cellEvent({
        key: 'add',
        item: {
          couponId: this.uuid.v4(),
          coupon: getRandomCode(),
          content:'',
          startDate: '',
          endDate: '',
          price:'',
          condition:'',
          isDelete: false,
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
